import * as tslib_1 from "tslib";
import { EventEmitter } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { NURSERIES_PATH, SPHERE_PATH } from "../../../crossconcern/utilities/properties/path.property";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { logData } from "../../../crossconcern/helpers/generic/generic.helper";
import { FRONTOFFICE_LOGIN_ROUTE, MAP_ROUTE, NURSERIES_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";
import { UserManager } from "../../../business/managers/user.manager";
import { LANG_CODE_EN, LANG_CODE_IT, VIRTUAL_TOUR_CONTACT_EMAIL, VIRTUAL_TOUR_FAQ_URL, SEARCH_DEBOUNCE_TIME, SEARCH_LETTER_TRESHOLD, LANG_CODE_FR } from "../../../crossconcern/utilities/properties/base.property";
import { TranslateService } from "@ngx-translate/core";
import { switchMap, distinctUntilChanged, debounceTime } from "rxjs/operators";
import { Subject } from "rxjs";
var FrontsidebarComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FrontsidebarComponent, _super);
    function FrontsidebarComponent(appComponent, router, location, userManager, photosphereManager, translate, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.userManager = userManager;
        _this.photosphereManager = photosphereManager;
        _this.translate = translate;
        _this.alertUtils = alertUtils;
        _this.onItemClick = new EventEmitter();
        _this.onSidebarLoaded = new EventEmitter();
        _this.onSidebarToggle = new EventEmitter();
        _this.nurseries = [];
        _this.searchSubject = new Subject();
        _this.placeholder = "SEARCHBAR_COMPONENT_BUTTON_PLACEHOLDER";
        return _this;
    }
    FrontsidebarComponent.prototype.ngOnInit = function () {
        this.emptySearchLabel = this.isInsideNursery ? "PRODUCTS_INFO_TEXT" : "NURSERIES_INFO_TEXT";
        this.email = VIRTUAL_TOUR_CONTACT_EMAIL;
        var language = this.photosphereManager.getCurrentLanguage();
        this.faqUrl = VIRTUAL_TOUR_FAQ_URL.replace("/it/", "/" + language + "/");
        this.setSearchSubject();
        this.onSidebarLoaded.emit();
    };
    FrontsidebarComponent.prototype.ngOnDestroy = function () {
        if (this.searchSubject != null && !this.searchSubject.closed) {
            this.searchSubject.unsubscribe();
        }
    };
    FrontsidebarComponent.prototype.onSearch = function () {
        var search = "";
        if (this.isInsideNursery) {
            var searchTerms = this.searchText.split(" ");
            searchTerms.forEach(function (term) {
                search += "var_dex:" + term + ",";
            });
        }
        else {
            search = "productOrNurseryName:" + this.searchText.replace(/\s/g, "---");
        }
        this.searchSubject.next(search);
    };
    FrontsidebarComponent.prototype.textChange = function () {
        if (this.searchText === "" && this.lastText !== "") {
            this.focusOut();
        }
        this.lastText = this.searchText;
        if (this.searchText !== undefined && this.searchText.length > SEARCH_LETTER_TRESHOLD) {
            this.onSearch();
        }
        else {
            this.products = null;
        }
    };
    FrontsidebarComponent.prototype.setSearchSubject = function () {
        var _this = this;
        this.searchSubject.pipe(debounceTime(SEARCH_DEBOUNCE_TIME), distinctUntilChanged(), switchMap(function (search) {
            return _this.photosphereManager.getProducts(search);
        })).subscribe(function (prods) {
            _this.products = [];
            _this.products = prods.filter(function (item) {
                if (_this.isInsideNursery) {
                    if (item.photospheres.length > 0) {
                        for (var _i = 0, _a = item.photospheres; _i < _a.length; _i++) {
                            var photosphere = _a[_i];
                            if (photosphere.nurseryUuid === _this.nurseries[0].uuid)
                                return true;
                        }
                        return false;
                    }
                    return false;
                }
                return item.photospheres.length > 0;
            });
            for (var _i = 0, _a = _this.products; _i < _a.length; _i++) {
                var product = _a[_i];
                product.photospheres.sort(function (x, y) {
                    if (x.uuid > y.uuid)
                        return -1;
                    if (x.uuid < y.uuid)
                        return 1;
                    return 0;
                });
                product.nurseries = [];
                var _loop_1 = function (photosphere) {
                    var nursery = _this.nurseries.find(function (item) {
                        return item.uuid === photosphere.nurseryUuid;
                    });
                    product.nurseries.push(nursery);
                };
                for (var _b = 0, _c = product.photospheres; _b < _c.length; _b++) {
                    var photosphere = _c[_b];
                    _loop_1(photosphere);
                }
            }
            logData(_this.nurseries);
        });
    };
    FrontsidebarComponent.prototype.focusOut = function () {
        this.products = null;
        this.searchText = "";
    };
    FrontsidebarComponent.prototype.itemClicked = function (item, nursery, nurseryIndex) {
        this.appComponent.startLoading();
        window.location.href = NURSERIES_PATH + "/" + SPHERE_PATH + "/" +
            nursery.uuid + "?start=" + item.photospheres[nurseryIndex].uuid;
    };
    FrontsidebarComponent.prototype.onBackClick = function () {
        if (this.isInsidePhotosphere) {
            this.goToRouteByName(MAP_ROUTE, { id: this.nurseries[0].uuid });
        }
        else {
            this.goToRouteByName(NURSERIES_ROUTE);
        }
    };
    FrontsidebarComponent.prototype.onLogoutClick = function () {
        this.userManager.logout();
        this.goToRouteByName(FRONTOFFICE_LOGIN_ROUTE);
    };
    FrontsidebarComponent.prototype.setLanguage = function (language) {
        this.translate.use(language);
        this.userManager.setCurrentLanguage(language);
        this.faqUrl = VIRTUAL_TOUR_FAQ_URL.replace("/it/", "/" + language + "/");
    };
    FrontsidebarComponent.prototype.setLanguageEnglish = function () {
        this.setLanguage(LANG_CODE_EN);
    };
    FrontsidebarComponent.prototype.setLanguageItalian = function () {
        this.setLanguage(LANG_CODE_IT);
    };
    FrontsidebarComponent.prototype.setLanguageFrench = function () {
        this.setLanguage(LANG_CODE_FR);
    };
    FrontsidebarComponent.prototype.currentLangItalian = function () {
        var currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_IT) {
            return true;
        }
        return false;
    };
    FrontsidebarComponent.prototype.currentLangEnglish = function () {
        var currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_EN) {
            return true;
        }
        return false;
    };
    FrontsidebarComponent.prototype.currentLangFrench = function () {
        var currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_FR) {
            return true;
        }
        return false;
    };
    FrontsidebarComponent.prototype.getProdName = function (productModel) {
        var language = this.photosphereManager.getCurrentLanguage();
        return this.getProductName(productModel, language);
    };
    return FrontsidebarComponent;
}(BaseComponent));
export { FrontsidebarComponent };
